import { CSSProperties } from 'react';

import { cx } from '@libs/classnames';

import styles from './BoardArrow.module.css';

export type Props = {
  className?: string;
  style?: {
    width?: CSSProperties['width'];
    height?: CSSProperties['height'];
    transform?: CSSProperties['transform'];
  };
  color?: 'green' | 'red' | 'yellow' | 'blue';
};

export function BoardArrow({ color = 'yellow', className, style }: Props) {
  return (
    // Используется техника sliding window, поэтому у стрелки есть ограничение
    // на максимальную ширину
    <svg
      className={cx(styles.arrow, className, {
        [styles.green]: color === 'green',
        [styles.red]: color === 'red',
        [styles.yellow]: color === 'yellow',
        [styles.blue]: color === 'blue',
      })}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <use href="#tail-arrow-7b3e2f5a4c91" x="0" y="0" width="50%" height="100%" />
      <use
        href="#head-arrow-7b3e2f5a4c91"
        width="50%"
        height="100%"
        style={{ translate: '50% 0' }}
      />
      <defs>
        <symbol
          id="tail-arrow-7b3e2f5a4c91"
          viewBox="0 0 1000 62"
          preserveAspectRatio="xMinYMid slice"
        >
          <path d="M0 29.364v3h1000v-3z" fill="currentColor" />
        </symbol>
        <symbol
          id="head-arrow-7b3e2f5a4c91"
          viewBox="0 0 1000 62"
          preserveAspectRatio="xMaxYMid slice"
        >
          <path
            d="M 0 29.364 v 3 h 998.5 v -3 z M 999.561 31.925 a 1.5 1.5 0 0 0 0 -2.121 l -7.778 -7.778 a 1.5 1.5 0 1 0 -2.121 2.121 l 6.717 6.717 l -6.717 6.717 a 1.5 1.5 0 1 0 2.121 2.121 z"
            fill="currentColor"
          />
        </symbol>
      </defs>
    </svg>
  );
}
